module.exports = __webpack_public_path__ + "static/images/tieren2.f6e66af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/tieren2.jpg
// module id = hM9b
// module chunks = 1